import createInstance from "./instance";
import me from "./me";

const userSvc = {
  createInstance,
  getUser: me.GET,
  updateUser: me.PUT,
};

export default userSvc;

export * from "./instance";
export * from "./schemas";
